import type { FC } from 'react';

import Pill from '@/common-components/Pill';
import type { ListingStatus } from '@/types/rental.types';

import { LISTING_STATUS_LABEL } from '../constants';

const ListingStatusPill: FC<{ status: ListingStatus }> = ({ status }) => {
  const meta = LISTING_STATUS_LABEL[status];
  return <Pill tone={meta.tone}>{meta.label}</Pill>;
};

export default ListingStatusPill;
